import { useLingui } from '@lingui/react';
import { type Country } from '../types';

const ICONS_API = 'https://static.elfsight.com/icons/';

export const useGetCountries = () => {
  const { i18n } = useLingui();
  const usa: Country = {
    countryCode: 'US',
    name: i18n._('United States'),
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-united-states-multicolor.svg`
  };

  const countries: Country[] = [
    {
      countryCode: 'AF',
      name: i18n._('Afghanistan'),
      phoneCode: '+93',
      iconSrc: `${ICONS_API}app-translator-afghanistan-multicolor.svg`
    },
    {
      countryCode: 'AL',
      name: i18n._('Albania'),
      phoneCode: '+355',
      iconSrc: `${ICONS_API}app-translator-albania-multicolor.svg`
    },
    {
      countryCode: 'AD',
      name: i18n._('Andorra'),
      phoneCode: '+376',
      iconSrc: `${ICONS_API}app-translator-andorra-multicolor.svg`
    },
    {
      countryCode: 'AO',
      name: i18n._('Angola'),
      phoneCode: '+244',
      iconSrc: `${ICONS_API}app-translator-angola-multicolor.svg`
    },
    {
      countryCode: 'AR',
      name: i18n._('Argentina'),
      phoneCode: '+54',
      iconSrc: `${ICONS_API}app-translator-argentina-multicolor.svg`
    },
    {
      countryCode: 'AM',
      name: i18n._('Armenia'),
      phoneCode: '+374',
      iconSrc: `${ICONS_API}app-translator-armenia-multicolor.svg`
    },
    {
      countryCode: 'AC',
      name: i18n._('Ascension Island'),
      phoneCode: '+247',
      iconSrc: `${ICONS_API}app-translator-ascension-island-multicolor.svg`
    },
    {
      countryCode: 'AU',
      name: i18n._('Australia'),
      phoneCode: '+61',
      iconSrc: `${ICONS_API}app-translator-australia-multicolor.svg`
    },
    {
      countryCode: 'AT',
      name: i18n._('Austria'),
      phoneCode: '+43',
      iconSrc: `${ICONS_API}app-translator-austria-multicolor.svg`
    },
    {
      countryCode: 'AZ',
      name: i18n._('Azerbaijan'),
      phoneCode: '+994',
      iconSrc: `${ICONS_API}app-translator-azerbaijan-multicolor.svg`
    },
    {
      countryCode: 'BH',
      name: i18n._('Bahrain'),
      phoneCode: '+973',
      iconSrc: `${ICONS_API}app-translator-bahrain-multicolor.svg`
    },
    {
      countryCode: 'BD',
      name: i18n._('Bangladesh'),
      phoneCode: '+880',
      iconSrc: `${ICONS_API}app-translator-bangladesh-multicolor.svg`
    },
    {
      countryCode: 'BB',
      name: i18n._('Barbados'),
      phoneCode: '+246',
      iconSrc: `${ICONS_API}app-translator-barbados-multicolor.svg`
    },
    {
      countryCode: 'BY',
      name: i18n._('Belarus'),
      phoneCode: '+375',
      iconSrc: `${ICONS_API}app-translator-belarus-multicolor.svg`
    },
    {
      countryCode: 'BE',
      name: i18n._('Belgium'),
      phoneCode: '+32',
      iconSrc: `${ICONS_API}app-translator-belgium-multicolor.svg`
    },
    {
      countryCode: 'BO',
      name: i18n._('Bolivia'),
      phoneCode: '+591',
      iconSrc: `${ICONS_API}app-translator-bolivia-multicolor.svg`
    },
    {
      countryCode: 'BA',
      name: i18n._('Bosnia and Herzegovina'),
      phoneCode: '+387',
      iconSrc: `${ICONS_API}app-translator-bosnia-and-herzegovina-multicolor.svg`
    },
    {
      countryCode: 'BR',
      name: i18n._('Brazil'),
      phoneCode: '+55',
      iconSrc: `${ICONS_API}app-translator-brazil-multicolor.svg`
    },
    {
      countryCode: 'BG',
      name: i18n._('Bulgaria'),
      phoneCode: '+359',
      iconSrc: `${ICONS_API}app-translator-bulgaria-multicolor.svg`
    },
    {
      countryCode: 'CV',
      name: i18n._('Cabo Verde'),
      phoneCode: '+238',
      iconSrc: `${ICONS_API}app-translator-cabo-verde-multicolor.svg`
    },
    {
      countryCode: 'KH',
      name: i18n._('Cambodia'),
      phoneCode: '+855',
      iconSrc: `${ICONS_API}app-translator-cambodia-multicolor.svg`
    },
    {
      countryCode: 'CM',
      name: i18n._('Cameroon'),
      phoneCode: '+237',
      iconSrc: `${ICONS_API}app-translator-cameroon-multicolor.svg`
    },
    {
      countryCode: 'CA',
      name: i18n._('Canada'),
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-canada-multicolor.svg`
    },
    {
      countryCode: 'BQ',
      name: i18n._('Caribbean Netherlands'),
      phoneCode: '+599',
      iconSrc: `${ICONS_API}app-translator-caribbean-netherlands-multicolor.svg`
    },
    {
      countryCode: 'CL',
      name: i18n._('Chile'),
      phoneCode: '+56',
      iconSrc: `${ICONS_API}app-translator-chile-multicolor.svg`
    },
    {
      countryCode: 'CN',
      name: i18n._('China'),
      phoneCode: '+86',
      iconSrc: `${ICONS_API}app-translator-china-multicolor.svg`
    },
    {
      countryCode: 'CO',
      name: i18n._('Colombia'),
      phoneCode: '+57',
      iconSrc: `${ICONS_API}app-translator-colombia-multicolor.svg`
    },
    {
      countryCode: 'CR',
      name: i18n._('Costa Rica'),
      phoneCode: '+506',
      iconSrc: `${ICONS_API}app-translator-costa-rica-multicolor.svg`
    },
    {
      countryCode: 'HR',
      name: i18n._('Croatia'),
      phoneCode: '+385',
      iconSrc: `${ICONS_API}app-translator-croatia-multicolor.svg`
    },
    {
      countryCode: 'CU',
      name: i18n._('Cuba'),
      phoneCode: '+53',
      iconSrc: `${ICONS_API}app-translator-cuba-multicolor.svg`
    },
    {
      countryCode: 'CY',
      name: i18n._('Cyprus'),
      phoneCode: '+357',
      iconSrc: `${ICONS_API}app-translator-cyprus-multicolor.svg`
    },
    {
      countryCode: 'CZ',
      name: i18n._('Czech Republic'),
      phoneCode: '+420',
      iconSrc: `${ICONS_API}app-translator-czech-republic-multicolor.svg`
    },
    {
      countryCode: 'CD',
      name: i18n._('Democratic Republic of the Congo'),
      phoneCode: '+243',
      iconSrc: `${ICONS_API}app-translator-democratic-republic-of-the-congo-multicolor.svg`
    },
    {
      countryCode: 'DK',
      name: i18n._('Denmark'),
      phoneCode: '+45',
      iconSrc: `${ICONS_API}app-translator-denmark-multicolor.svg`
    },
    {
      countryCode: 'DO',
      name: i18n._('Dominican Republic'),
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-dominican-republic-multicolor.svg`
    },
    {
      countryCode: 'EC',
      name: i18n._('Ecuador'),
      phoneCode: '+593',
      iconSrc: `${ICONS_API}app-translator-ecuador-multicolor.svg`
    },
    {
      countryCode: 'EG',
      name: i18n._('Egypt'),
      phoneCode: '+20',
      iconSrc: `${ICONS_API}app-translator-egypt-multicolor.svg`
    },
    {
      countryCode: 'SV',
      name: i18n._('El Salvador'),
      phoneCode: '+503',
      iconSrc: `${ICONS_API}app-translator-el-salvador-multicolor.svg`
    },
    {
      countryCode: 'ER',
      name: i18n._('Eritrea'),
      phoneCode: '+291',
      iconSrc: `${ICONS_API}app-translator-eritrea-multicolor.svg`
    },
    {
      countryCode: 'EE',
      name: i18n._('Estonia'),
      phoneCode: '+372',
      iconSrc: `${ICONS_API}app-translator-estonia-multicolor.svg`
    },
    {
      countryCode: 'SZ',
      name: i18n._('Eswatini'),
      phoneCode: '+268',
      iconSrc: `${ICONS_API}app-translator-eswatini-multicolor.svg`
    },
    {
      countryCode: 'ET',
      name: i18n._('Ethiopia'),
      phoneCode: '+251',
      iconSrc: `${ICONS_API}app-translator-ethiopia-multicolor.svg`
    },
    {
      countryCode: 'FI',
      name: i18n._('Finland'),
      phoneCode: '+358',
      iconSrc: `${ICONS_API}app-translator-finland-multicolor.svg`
    },
    {
      countryCode: 'FR',
      name: i18n._('France'),
      phoneCode: '+33',
      iconSrc: `${ICONS_API}app-translator-france-multicolor.svg`
    },
    {
      countryCode: 'GM',
      name: i18n._('Gambia'),
      phoneCode: '+220',
      iconSrc: `${ICONS_API}app-translator-gambia-multicolor.svg`
    },
    {
      countryCode: 'GE',
      name: i18n._('Georgia'),
      phoneCode: '+995',
      iconSrc: `${ICONS_API}app-translator-georgia-multicolor.svg`
    },
    {
      countryCode: 'DE',
      name: i18n._('Germany'),
      phoneCode: '+49',
      iconSrc: `${ICONS_API}app-translator-germany-multicolor.svg`
    },
    {
      countryCode: 'GH',
      name: i18n._('Ghana'),
      phoneCode: '+233',
      iconSrc: `${ICONS_API}app-translator-ghana-multicolor.svg`
    },
    {
      countryCode: 'GR',
      name: i18n._('Greece'),
      phoneCode: '+30',
      iconSrc: `${ICONS_API}app-translator-greece-multicolor.svg`
    },
    {
      countryCode: 'GT',
      name: i18n._('Guatemala'),
      phoneCode: '+502',
      iconSrc: `${ICONS_API}app-translator-guatemala-multicolor.svg`
    },
    {
      countryCode: 'GN',
      name: i18n._('Guinea'),
      phoneCode: '+224',
      iconSrc: `${ICONS_API}app-translator-guinea-multicolor.svg`
    },
    {
      countryCode: 'GY',
      name: i18n._('Guyana'),
      phoneCode: '+592',
      iconSrc: `${ICONS_API}app-translator-guyana-multicolor.svg`
    },
    {
      countryCode: 'HT',
      name: i18n._('Haiti'),
      phoneCode: '+509',
      iconSrc: `${ICONS_API}app-translator-haiti-multicolor.svg`
    },
    {
      countryCode: 'HN',
      name: i18n._('Honduras'),
      phoneCode: '+504',
      iconSrc: `${ICONS_API}app-translator-honduras-multicolor.svg`
    },
    {
      countryCode: 'HK',
      name: i18n._('Hong Kong'),
      phoneCode: '+852',
      iconSrc: `${ICONS_API}app-translator-hong-kong-multicolor.svg`
    },
    {
      countryCode: 'HU',
      name: i18n._('Hungary'),
      phoneCode: '+36',
      iconSrc: `${ICONS_API}app-translator-hungary-multicolor.svg`
    },
    {
      countryCode: 'IS',
      name: i18n._('Iceland'),
      phoneCode: '+354',
      iconSrc: `${ICONS_API}app-translator-iceland-multicolor.svg`
    },
    {
      countryCode: 'IN',
      name: i18n._('India'),
      phoneCode: '+91',
      iconSrc: `${ICONS_API}app-translator-india-multicolor.svg`
    },
    {
      countryCode: 'ID',
      name: i18n._('Indonesia'),
      phoneCode: '+62',
      iconSrc: `${ICONS_API}app-translator-indonesia-multicolor.svg`
    },
    {
      countryCode: 'IR',
      name: i18n._('Iran'),
      phoneCode: '+98',
      iconSrc: `${ICONS_API}app-translator-iran-multicolor.svg`
    },
    {
      countryCode: 'IQ',
      name: i18n._('Iraq'),
      phoneCode: '+964',
      iconSrc: `${ICONS_API}app-translator-iraq-multicolor.svg`
    },
    {
      countryCode: 'IE',
      name: i18n._('Ireland'),
      phoneCode: '+353',
      iconSrc: `${ICONS_API}app-translator-ireland-multicolor.svg`
    },
    {
      countryCode: 'IL',
      name: i18n._('Israel'),
      phoneCode: '+972',
      iconSrc: `${ICONS_API}app-translator-israel-multicolor.svg`
    },
    {
      countryCode: 'IT',
      name: i18n._('Italy'),
      phoneCode: '+39',
      iconSrc: `${ICONS_API}app-translator-italy-multicolor.svg`
    },
    {
      countryCode: 'JP',
      name: i18n._('Japan'),
      phoneCode: '+81',
      iconSrc: `${ICONS_API}app-translator-japan-multicolor.svg`
    },
    {
      countryCode: 'JO',
      name: i18n._('Jordan'),
      phoneCode: '+962',
      iconSrc: `${ICONS_API}app-translator-jordan-multicolor.svg`
    },
    {
      countryCode: 'KZ',
      name: i18n._('Kazakhstan'),
      phoneCode: '+7',
      iconSrc: `${ICONS_API}app-translator-kazakhstan-multicolor.svg`
    },
    {
      countryCode: 'KE',
      name: i18n._('Kenya'),
      phoneCode: '+254',
      iconSrc: `${ICONS_API}app-translator-kenia-multicolor.svg`
    },
    {
      countryCode: 'KW',
      name: i18n._('Kuwait'),
      phoneCode: '+965',
      iconSrc: `${ICONS_API}app-translator-kuwait-multicolor.svg`
    },
    {
      countryCode: 'KG',
      name: i18n._('Kyrgyzstan'),
      phoneCode: '+996',
      iconSrc: `${ICONS_API}app-translator-kyrgyzstan-multicolor.svg`
    },
    {
      countryCode: 'LA',
      name: i18n._('Laos'),
      phoneCode: '+856',
      iconSrc: `${ICONS_API}app-translator-laos-multicolor.svg`
    },
    {
      countryCode: 'LV',
      name: i18n._('Latvia'),
      phoneCode: '+371',
      iconSrc: `${ICONS_API}app-translator-latvia-multicolor.svg`
    },
    {
      countryCode: 'LB',
      name: i18n._('Lebanon'),
      phoneCode: '+961',
      iconSrc: `${ICONS_API}app-translator-lebanon-multicolor.svg`
    },
    {
      countryCode: 'LS',
      name: i18n._('Lesotho'),
      phoneCode: '+266',
      iconSrc: `${ICONS_API}app-translator-lesotho-multicolor.svg`
    },
    {
      countryCode: 'LI',
      name: i18n._('Liechtenstein'),
      phoneCode: '+423',
      iconSrc: `${ICONS_API}app-translator-liechtenstein-multicolor.svg`
    },
    {
      countryCode: 'LT',
      name: i18n._('Lithuania'),
      phoneCode: '+370',
      iconSrc: `${ICONS_API}app-translator-lithuania-multicolor.svg`
    },
    {
      countryCode: 'LU',
      name: i18n._('Luxembourg'),
      phoneCode: '+352',
      iconSrc: `${ICONS_API}app-translator-luxembourg-multicolor.svg`
    },
    {
      countryCode: 'MG',
      name: i18n._('Madagascar'),
      phoneCode: '+261',
      iconSrc: `${ICONS_API}app-translator-madagascar-multicolor.svg`
    },
    {
      countryCode: 'MW',
      name: i18n._('Malawi'),
      phoneCode: '+265',
      iconSrc: `${ICONS_API}app-translator-malawi-multicolor.svg`
    },
    {
      countryCode: 'MY',
      name: i18n._('Malaysia'),
      phoneCode: '+60',
      iconSrc: `${ICONS_API}app-translator-malaysia-multicolor.svg`
    },
    {
      countryCode: 'MV',
      name: i18n._('Maldives'),
      phoneCode: '+960',
      iconSrc: `${ICONS_API}app-translator-maldives-multicolor.svg`
    },
    {
      countryCode: 'ML',
      name: i18n._('Mali'),
      phoneCode: '+223',
      iconSrc: `${ICONS_API}app-translator-mali-multicolor.svg`
    },
    {
      countryCode: 'MT',
      name: i18n._('Malta'),
      phoneCode: '+356',
      iconSrc: `${ICONS_API}app-translator-malta-multicolor.svg`
    },
    {
      countryCode: 'MR',
      name: i18n._('Mauritania'),
      phoneCode: '+222',
      iconSrc: `${ICONS_API}app-translator-mauritania-multicolor.svg`
    },
    {
      countryCode: 'MX',
      name: i18n._('Mexico'),
      phoneCode: '+52',
      iconSrc: `${ICONS_API}app-translator-mexico-multicolor.svg`
    },
    {
      countryCode: 'MD',
      name: i18n._('Moldova'),
      phoneCode: '+373',
      iconSrc: `${ICONS_API}app-translator-moldova-multicolor.svg`
    },
    {
      countryCode: 'MN',
      name: i18n._('Mongolia'),
      phoneCode: '+976',
      iconSrc: `${ICONS_API}app-translator-mongolia-multicolor.svg`
    },
    {
      name: i18n._('Mozambique'),
      countryCode: 'MZ',
      phoneCode: '+258',
      iconSrc: `${ICONS_API}app-translator-mozambique-multicolor.svg`
    },
    {
      countryCode: 'MM',
      name: i18n._('Myanmar'),
      phoneCode: '+95',
      iconSrc: `${ICONS_API}app-translator-myanmar-multicolor.svg`
    },
    {
      countryCode: 'NA',
      name: i18n._('Namibia'),
      phoneCode: '+264',
      iconSrc: `${ICONS_API}app-translator-namibia-multicolor.svg`
    },
    {
      countryCode: 'NP',
      name: i18n._('Nepal'),
      phoneCode: '+977',
      iconSrc: `${ICONS_API}app-translator-nepal-multicolor.svg`
    },
    {
      countryCode: 'NL',
      name: i18n._('Netherlands'),
      phoneCode: '+31',
      iconSrc: `${ICONS_API}app-translator-netherlands-multicolor.svg`
    },
    {
      countryCode: 'NC',
      name: i18n._('New Caledonia'),
      phoneCode: '+687',
      iconSrc: `${ICONS_API}app-translator-france-multicolor.svg`
    },
    {
      countryCode: 'NZ',
      name: i18n._('New Zealand'),
      phoneCode: '+64',
      iconSrc: `${ICONS_API}app-translator-new-zealand-multicolor.svg`
    },
    {
      countryCode: 'NI',
      name: i18n._('Nicaragua'),
      phoneCode: '+505',
      iconSrc: `${ICONS_API}app-translator-nicaragua-multicolor.svg`
    },
    {
      countryCode: 'NG',
      name: i18n._('Nigeria'),
      phoneCode: '+234',
      iconSrc: `${ICONS_API}app-translator-nigeria-multicolor.svg`
    },
    {
      countryCode: 'MK',
      name: i18n._('North Macedonia'),
      phoneCode: '+389',
      iconSrc: `${ICONS_API}app-translator-north-macedonia-multicolor.svg`
    },
    {
      countryCode: 'NO',
      name: i18n._('Norway'),
      phoneCode: '+47',
      iconSrc: `${ICONS_API}app-translator-norway-multicolor.svg`
    },
    {
      countryCode: 'OM',
      name: i18n._('Oman'),
      phoneCode: '+968',
      iconSrc: `${ICONS_API}app-translator-oman-multicolor.svg`
    },
    {
      countryCode: 'PK',
      name: i18n._('Pakistan'),
      phoneCode: '+92',
      iconSrc: `${ICONS_API}app-translator-pakistan-multicolor.svg`
    },
    {
      countryCode: 'PA',
      name: i18n._('Panama'),
      phoneCode: '+507',
      iconSrc: `${ICONS_API}app-translator-panama-multicolor.svg`
    },
    {
      countryCode: 'PG',
      name: i18n._('Papua New Guinea'),
      phoneCode: '+675',
      iconSrc: `${ICONS_API}app-translator-papua-new-guinea-multicolor.svg`
    },
    {
      countryCode: 'PY',
      name: i18n._('Paraguay'),
      phoneCode: '+595',
      iconSrc: `${ICONS_API}app-translator-paraguay-multicolor.svg`
    },
    {
      countryCode: 'PE',
      name: i18n._('Peru'),
      phoneCode: '+51',
      iconSrc: `${ICONS_API}app-translator-peru-multicolor.svg`
    },
    {
      countryCode: 'PH',
      name: i18n._('Philippines'),
      phoneCode: '+63',
      iconSrc: `${ICONS_API}app-translator-philippines-multicolor.svg`
    },
    {
      countryCode: 'PL',
      name: i18n._('Poland'),
      phoneCode: '+48',
      iconSrc: `${ICONS_API}app-translator-poland-multicolor.svg`
    },
    {
      countryCode: 'PT',
      name: i18n._('Portugal'),
      phoneCode: '+351',
      iconSrc: `${ICONS_API}app-translator-portugal-multicolor.svg`
    },
    {
      countryCode: 'QA',
      name: i18n._('Qatar'),
      phoneCode: '+974',
      iconSrc: `${ICONS_API}app-translator-qatar-multicolor.svg`
    },
    {
      countryCode: 'CG',
      name: i18n._('Republic of the Congo'),
      phoneCode: '+242',
      iconSrc: `${ICONS_API}app-translator-republic-of-the-congo-multicolor.svg`
    },
    {
      countryCode: 'RO',
      name: i18n._('Romania'),
      phoneCode: '+40',
      iconSrc: `${ICONS_API}app-translator-romania-multicolor.svg`
    },
    {
      countryCode: 'RU',
      name: i18n._('Russian Federation'),
      phoneCode: '+7',
      iconSrc: `${ICONS_API}app-translator-russian-federation-multicolor.svg`
    },
    {
      countryCode: 'RW',
      name: i18n._('Rwanda'),
      phoneCode: '+250',
      iconSrc: `${ICONS_API}app-translator-rwanda-multicolor.svg`
    },
    {
      countryCode: 'KN',
      name: i18n._('Saint Kitts and Nevis'),
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-st-kitts-and-nevis-multicolor.svg`
    },
    {
      countryCode: 'LC',
      name: i18n._('Saint Lucia'),
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-saint-lucia-multicolor.svg`
    },
    {
      countryCode: 'MF',
      name: i18n._('Saint Martin'),
      phoneCode: '+590',
      iconSrc: `${ICONS_API}app-translator-st-martin-multicolor.svg`
    },
    {
      countryCode: 'VC',
      name: i18n._('Saint Vincent and Grenadines'),
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-st-vincent-and-grenadines-multicolor.svg`
    },
    {
      countryCode: 'WS',
      name: i18n._('Samoa'),
      phoneCode: '+685',
      iconSrc: `${ICONS_API}app-translator-samoa-multicolor.svg`
    },
    {
      countryCode: 'SA',
      name: i18n._('Saudi Arabia'),
      phoneCode: '+966',
      iconSrc: `${ICONS_API}app-translator-saudi-arabia-multicolor.svg`
    },
    {
      countryCode: 'SN',
      name: i18n._('Senegal'),
      phoneCode: '+221',
      iconSrc: `${ICONS_API}app-translator-senegal-multicolor.svg`
    },
    {
      countryCode: 'RS',
      name: i18n._('Serbia'),
      phoneCode: '+381',
      iconSrc: `${ICONS_API}app-translator-serbia-multicolor.svg`
    },
    {
      countryCode: 'SL',
      name: i18n._('Sierra Leone'),
      phoneCode: '+232',
      iconSrc: `${ICONS_API}app-translator-sierra-leone-multicolor.svg`
    },
    {
      countryCode: 'SG',
      name: i18n._('Singapore'),
      phoneCode: '+65',
      iconSrc: `${ICONS_API}app-translator-singapore-multicolor.svg`
    },
    {
      countryCode: 'SK',
      name: i18n._('Slovakia'),
      phoneCode: '+421',
      iconSrc: `${ICONS_API}app-translator-slovakia-multicolor.svg`
    },
    {
      countryCode: 'SI',
      name: i18n._('Slovenia'),
      phoneCode: '+386',
      iconSrc: `${ICONS_API}app-translator-slovenia-multicolor.svg`
    },
    {
      countryCode: 'SO',
      name: i18n._('Somalia'),
      phoneCode: '+252',
      iconSrc: `${ICONS_API}app-translator-somalia-multicolor.svg`
    },
    {
      countryCode: 'ZA',
      name: i18n._('South Africa'),
      phoneCode: '+27',
      iconSrc: `${ICONS_API}app-translator-south-africa-multicolor.svg`
    },
    {
      countryCode: 'KR',
      name: i18n._('South Korea'),
      phoneCode: '+82',
      iconSrc: `${ICONS_API}app-translator-south-korea-multicolor.svg`
    },
    {
      countryCode: 'ES',
      name: i18n._('Spain'),
      phoneCode: '+34',
      iconSrc: `${ICONS_API}app-translator-spain-multicolor.svg`
    },
    {
      countryCode: 'LK',
      name: i18n._('Sri Lanka'),
      phoneCode: '+94',
      iconSrc: `${ICONS_API}app-translator-sri-lanka-multicolor.svg`
    },
    {
      countryCode: 'SJ',
      name: i18n._('Svalbard and Jan Mayen'),
      phoneCode: '+47',
      iconSrc: `${ICONS_API}app-translator-svalbard-and-jan-mayen-multicolor.svg`
    },
    {
      countryCode: 'SE',
      name: i18n._('Sweden'),
      phoneCode: '+46',
      iconSrc: `${ICONS_API}app-translator-sweden-multicolor.svg`
    },
    {
      countryCode: 'CH',
      name: i18n._('Switzerland'),
      phoneCode: '+41',
      iconSrc: `${ICONS_API}app-translator-switzerland-multicolor.svg`
    },
    {
      countryCode: 'TW',
      name: i18n._('Taiwan'),
      phoneCode: '+886',
      iconSrc: `${ICONS_API}app-translator-taiwan-multicolor.svg`
    },
    {
      countryCode: 'TJ',
      name: i18n._('Tajikistan'),
      phoneCode: '+992',
      iconSrc: `${ICONS_API}app-translator-tajikistan-multicolor.svg`
    },
    {
      countryCode: 'TZ',
      name: i18n._('Tanzania'),
      phoneCode: '+255',
      iconSrc: `${ICONS_API}app-translator-tanzania-multicolor.svg`
    },
    {
      countryCode: 'TH',
      name: i18n._('Thailand'),
      phoneCode: '+66',
      iconSrc: `${ICONS_API}app-translator-thailand-multicolor.svg`
    },
    {
      countryCode: 'TG',
      name: i18n._('Togo'),
      phoneCode: '+228',
      iconSrc: `${ICONS_API}app-translator-togo-multicolor.svg`
    },
    {
      countryCode: 'TT',
      name: i18n._('Trinidad and Tobago'),
      phoneCode: '+1',
      iconSrc: `${ICONS_API}app-translator-trinidad-and-tobago-multicolor.svg`
    },
    {
      countryCode: 'TN',
      name: i18n._('Tunisia'),
      phoneCode: '+216',
      iconSrc: `${ICONS_API}app-translator-tunisia-multicolor.svg`
    },
    {
      countryCode: 'TR',
      name: i18n._('Turkey'),
      phoneCode: '+90',
      iconSrc: `${ICONS_API}app-translator-turkey-multicolor.svg`
    },
    {
      countryCode: 'TM',
      name: i18n._('Turkmenistan'),
      phoneCode: '+993',
      iconSrc: `${ICONS_API}app-translator-turkmenistan-multicolor.svg`
    },
    {
      countryCode: 'UG',
      name: i18n._('Uganda'),
      phoneCode: '+256',
      iconSrc: `${ICONS_API}app-translator-uganda-multicolor.svg`
    },
    {
      countryCode: 'UA',
      name: i18n._('Ukraine'),
      phoneCode: '+380',
      iconSrc: `${ICONS_API}app-translator-ukraine-multicolor.svg`
    },
    {
      countryCode: 'AE',
      name: i18n._('United Arab Emirates'),
      phoneCode: '+971',
      iconSrc: `${ICONS_API}app-translator-united-arab-emirates-multicolor.svg`
    },
    {
      countryCode: 'GB',
      name: i18n._('United Kingdom'),
      phoneCode: '+44',
      iconSrc: `${ICONS_API}app-translator-united-kingdom-multicolor.svg`
    },
    usa,
    {
      countryCode: 'UY',
      name: i18n._('Uruguay'),
      phoneCode: '+598',
      iconSrc: `${ICONS_API}app-translator-uruguay-multicolor.svg`
    },
    {
      countryCode: 'UZ',
      name: i18n._('Uzbekistan'),
      phoneCode: '+998',
      iconSrc: `${ICONS_API}app-translator-uzbekistan-multicolor.svg`
    },
    {
      countryCode: 'VE',
      name: i18n._('Venezuela'),
      phoneCode: '+58',
      iconSrc: `${ICONS_API}app-translator-venezuela-multicolor.svg`
    },
    {
      countryCode: 'VN',
      name: i18n._('Vietnam'),
      phoneCode: '+84',
      iconSrc: `${ICONS_API}app-translator-vietnam-multicolor.svg`
    },
    {
      countryCode: 'YE',
      name: i18n._('Yemen'),
      phoneCode: '+967',
      iconSrc: `${ICONS_API}app-translator-yemen-multicolor.svg`
    },
    {
      countryCode: 'ZM',
      name: i18n._('Zambia'),
      phoneCode: '+260',
      iconSrc: `${ICONS_API}app-translator-zambia-multicolor.svg`
    },
    {
      countryCode: 'ZW',
      name: i18n._('Zimbabwe'),
      phoneCode: '+263',
      iconSrc: `${ICONS_API}app-translator-zimbabwe-multicolor.svg`
    }
  ];

  return { usa, countries };
};
